export function isNullOrWhiteSpace(str) {
    return !str || /^\s*$/.test(str);
}
window.isNullOrWhiteSpace = isNullOrWhiteSpace;
String.prototype.lpad = function (padString, length) {
    var str = this;
    while (str.length < length)
        str = padString + str;
    return str;
};
String.prototype.trimChars = function (c) {
    c = c.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    var regEx = new RegExp("^[" + c + "]+|[" + c + "]+$", "g");
    return this.replace(regEx, "");
};
String.prototype.encodeForHtml = function () {
    var elt = document.createElement('span');
    elt.textContent = this;
    return elt.innerHTML
        .replace(/\r\n/g, "<br>")
        .replace(/\r/g, "<br>")
        .replace(/\n/g, "<br>");
};
String.prototype.supplant = function (o) {
    return this.replace(/{([^{}]*)}/g, function (a, b) {
        var r = o[b];
        return typeof r === 'string' || typeof r === 'number' ? r : a;
    });
};
